import React, { forwardRef } from "react";

import { Gap } from "../../../../helpers/common/Gap/Gap";
import { Content, ContentsView } from "../../../Content";
import { Illustration } from "../../../Illustration";
import { createDisplayNameForSearchElement } from "../../utils/getDisplayName";
import { createTestIdForSearchElement } from "../../utils/getTestId";

import classes from "./SearchNotFoundStub.styl";

const NOT_FOUND_STUB_DISPLAY_NAME = "SearchNotFoundStub";
const NOT_FOUND_TEST_ID = createTestIdForSearchElement("not-found");

export interface ISearchNotFoundStub {
    notFoundTitle: string;
    notFoundDescription: string;
    imgAlt: string;
    imgSrc: string;
}

export const SearchNotFoundStub = forwardRef<
    HTMLDivElement,
    ISearchNotFoundStub
>(({ notFoundTitle, notFoundDescription, imgSrc, imgAlt, ...props }, ref) => {
    return (
        <Gap
            {...props}
            className={classes["not-found-stub-wrapper"]}
            contentClassName={classes["not-found-stub"]}
            data-tsid={NOT_FOUND_TEST_ID}
            data-uikit={NOT_FOUND_STUB_DISPLAY_NAME}
            ref={ref}
        >
            <Illustration size="72" src={imgSrc} alt={imgAlt} />
            <ContentsView>
                <ContentsView.Row size="17">
                    <ContentsView.Content alignmentX="center">
                        <Content.Text view="primary" maxLines={1} size="17b">
                            {notFoundTitle}
                        </Content.Text>
                    </ContentsView.Content>
                </ContentsView.Row>
                <ContentsView.Row size="15">
                    <ContentsView.Content alignmentX="center">
                        <Content.Text view="secondary" size="15" maxLines={1}>
                            {notFoundDescription}
                        </Content.Text>
                    </ContentsView.Content>
                </ContentsView.Row>
            </ContentsView>
        </Gap>
    );
});

SearchNotFoundStub.displayName = createDisplayNameForSearchElement(
    NOT_FOUND_STUB_DISPLAY_NAME,
);

export default SearchNotFoundStub;
